

















import { mapState } from "vuex";
import { Component, Prop, Vue } from "vue-property-decorator";
import globals from "@/general/store/modules/globals";

import SmallText from "@/common/components/atoms/SmallText.vue";

@Component({
  components: {
    SmallText
  }
})
export default class IInvestedStandardListPanel extends Vue {
  get textSize() {
    const isSp = globals.isSpScreenWidth;
    return (textSize: number) => (isSp ? textSize - 2 : textSize);
  }
}
